<template>
  <div :class="`header-container ${alignBarStart ? 'alignBarStart' : ''}`">
    <h4>The "Cohere" Collection</h4>
    <div class="gray-bar" />
  </div>
</template>


<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    alignBarStart: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.alignBarStart {
  align-items: flex-start !important;
}
.header-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  h4 {
    font-family: "Poppins-Bold";
    font-size: 34px;
    color: #1a1a1a;
    letter-spacing: 0;
    text-align: center;
    line-height: 42px;
    margin-bottom: 20px;
    text-transform: uppercase;
  }
  .gray-bar {
    width: 70%;
    height: 4px;
    background: #eaeaea;
  }
}
</style>


